import axios from "axios";

let handledDisabled = false;

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const res = error?.response;

      // If server says "this account is disabled"
      if (!handledDisabled && res?.status === 403 && res?.data?.code === "ACCOUNT_DISABLED") {
        handledDisabled = true;

        // 1) remove token (logs them out)
        localStorage.removeItem("authToken");

        // 2) tell the user
        alert("Your account has been disabled due to suspicious activity. Please contact support for more information.");

        // 3) send them to login
        window.location.href = "/login";

        return; // stop here
      }

      // for other errors, let your existing code handle them
      return Promise.reject(error);
    }
  );
}
